import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} StudentResponseItem
 * @property {number} id
 * @property {string} tenant_id
 * @property {string | number} inst_id
 * @property {string} name
 * @property {string} username
 * @property {string} email
 * @property {string | number} age
 * @property {string | number} assigned_to
 * @property {string} status
 * @property {string} student_code
 * @property {string | null} assigned_teacher
 */

/**
 * @typedef {object} GetStudentParams
 * @property {number} studentId - Student ID (required for individual fetch)
 */

export const useGetStudent = () => {
  const [student, setStudent] = useState(
    /** @type {StudentResponseItem | null} */ (null)
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  /**
   * Fetch individual student details
   * @async
   * @param {GetStudentParams} params
   */
  const getStudent = async ({ studentId } = {}) => {
    if (!studentId) {
      setError("Student ID is required");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const url = `${TENANT_DOMAIN}/school/admin/student/${studentId}`;

      const response = await axiosInstance.get(url);

      setStudent(response?.data.data || null);
    } catch (err) {
      setStudent(null);
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    student,
    loading,
    error,
    getStudent,
  };
};
